import * as React from 'react';
import LinearProgress, {LinearProgressProps } from '@material-ui/core/LinearProgress';
import Box from '@material-ui/core/Box';
import { createStyles, Theme, withStyles } from '@material-ui/core';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';

export default function LinearProgressInternal(props: LinearProgressProps & { value: number }) {
    const [progress, setProgress] = React.useState(0);
    const checkOutState = React.useContext(CheckOutStateContext);

    const BorderLinearProgress = withStyles((theme: Theme) =>
        createStyles({
            root: {
                height: 6,
                borderRadius: 3,
            },
            colorPrimary: {
                backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
            },
            bar: {
                borderRadius: 6,
                backgroundColor: checkOutState.state.skin.primary_main_color,
            },
        }),
    )(LinearProgress);

    return (
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <BorderLinearProgress variant="determinate" {...props} />
            </Box>
      </Box>
    );
}

